import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
	'use strict';

	angular
        .module('surveyCampaignControllers')
        .factory('surveyCampaignService', service);

	service.$inject = ['$http', '$q', 'env'];

	function service($http, $q, env) {
		var baseUrl = environment.apiUrl + '/Pilot/api/Survey';

		var campaignUrl = function (slugObject) {
		    return baseUrl + '/Campaign/' +
                   slugObject.Year + '/' + slugObject.Month + '/' + slugObject.Day + '/' +
                   slugObject.Title;
		}

		var service = {
			getAllActiveCampaigns             : getAllActiveCampaigns,
			getCampaign                       : getCampaign,
            lockCampaign                      : lockCampaign,
            createCampaign                    : createCampaign,
            updateCampaign                    : updateCampaign,
			createCampaignPart                : createCampaignPart,
			updateCampaignPart                : updateCampaignPart,
			deleteCampaignPart                : deleteCampaignPart,
			getCampaignParts                  : getCampaignParts,
			orderCampaignPartComponents       : orderCampaignPartComponents,
			getQuestionTypes                  : getQuestionTypes,
			createQuestion                    : createQuestion,
            updateQuestion                    : updateQuestion,
            deleteQuestion                    : deleteQuestion,
            duplicateQuestion                 : duplicateQuestion,
			createQuestionChoice              : createQuestionChoice,
			updateQuestionChoice              : updateQuestionChoice,
			deleteQuestionChoice              : deleteQuestionChoice,
			createVisualComponent             : createVisualComponent,
			deleteVisualComponent             : deleteVisualComponent,
			addCampaignRespondent             : addCampaignRespondent,
			addRespondentWithSubordinates     : addRespondentWithSubordinates,
			removeCampaignRespondent          : removeCampaignRespondent,
			unlockCompletionCampaignRespondent: unlockCompletionCampaignRespondent,
			getCampaignRespondents            : getCampaignRespondents,
			sendEmailToRepondent              : sendEmailToRepondent,
			getCampaignOwners                 : getCampaignOwners,
			addCampaignOwner                  : addCampaignOwner,
			removeCampaignOwner               : removeCampaignOwner,
		};
		return service;

		////////////

		// Campaigns

		function getAllActiveCampaigns() {
			var reqUrl = baseUrl + '/Campaign/Active';

			return $http.get(reqUrl)
                        .then(function (response) {
                        	return response.data;
                        });
		}

		function getCampaign(slugObject) {
		    var reqUrl = campaignUrl(slugObject);

			return $http.get(reqUrl)
                        .then(function (response) {
                        	return response.data;
                        });
		}

		function lockCampaign(slugObject) {
		    var reqUrl = campaignUrl(slugObject);

		    return $http.delete(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}

		function createCampaign(campaign) {
			var reqUrl = baseUrl + '/Campaign';

			return $http.post(reqUrl, { Campaign: campaign})
                        .then(function (response) {
                        	return response.data;
                        });
		}

		function updateCampaign(slugObject, campaign) {
		    var reqUrl = campaignUrl(slugObject);

		    return $http.put(reqUrl, campaign)
                        .then(function (response) {
                            return response.data;
                        });
		}


		// Campaign Part

		function createCampaignPart(slugObject, campaignPart) {
		    var reqUrl = campaignUrl(slugObject) +
                         '/Part';

		    return $http.post(reqUrl, {
		        CampaignPart: campaignPart
		    })
            .then(function (response) {
                return response.data;
            });
		}

		function updateCampaignPart(slugObject, campaignPart) {
		    var reqUrl = campaignUrl(slugObject) +
                         '/Part/' + campaignPart.CampaignPartID;

		    return $http.put(reqUrl, {
		        CampaignPart: campaignPart
		    })
            .then(function (response) {
                return response.data;
            });
		}

		function deleteCampaignPart(slugObject, campaignPart) {
		    var reqUrl = campaignUrl(slugObject) +
                         '/Part/' + campaignPart.CampaignPartID;

		    return $http.delete(reqUrl, {})
                        .then(function (response) {
                            return response.data;
                        });
		}

		function getCampaignParts(slugObject) {
		    var reqUrl = campaignUrl(slugObject) +
                         '/Part';

			return $http.get(reqUrl)
                        .then(function (response) {
                        	return response.data;
                        });
		}

		function orderCampaignPartComponents(slugObject, campaignPartId, components) {
		    var componentIdList = _.map(components, 'CampaignComponentID');

		    var reqUrl = campaignUrl(slugObject) +
						 '/Part/' + campaignPartId +
						 '/Order';

		    return $http.post(reqUrl, { componentIdList: componentIdList })
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Question Type

		function getQuestionTypes() {
		    var reqUrl = baseUrl +
						 '/QuestionType';

		    return $http.get(reqUrl, {})
                        .then(function (response) {
                            return response.data;
                        });
		}

		// Question

		function createQuestion(slugObject, campaignPartId, question) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/Part/' + campaignPartId +
						 '/Question';

			return $http.post(reqUrl, { Question: question })
                        .then(function (response) {
                        	return response.data;
                        });
		}

		function updateQuestion(slugObject, campaignPartId, question) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/Part/' + campaignPartId +
						 '/Question/' + question.QuestionID;

		    return $http.put(reqUrl, { Question: question })
                        .then(function (response) {
                            return response.data;
                        });
		}

		function deleteQuestion(slugObject, campaignPartId, question) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/Part/' + campaignPartId +
						 '/Question/' + question.QuestionID;

		    return $http.delete(reqUrl, {})
                        .then(function (response) {
                            return response.data;
                        });
		}

		function duplicateQuestion(slugObject, campaignPartId, question) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/Part/' + campaignPartId +
						 '/Question/' + question.QuestionID +
		                 '/Duplicate';

		    return $http.post(reqUrl, { Question: question })
                        .then(function (response) {
                            return response.data;
                        });
		}

		// Question Choice

		function createQuestionChoice(slugObject, campaignPartId, questionId, choice) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/Part/' + campaignPartId +
						 '/Question/' + questionId +
						 '/Choice';

			return $http.post(reqUrl, { Choice: choice })
                        .then(function (response) {
                        	return response.data;
                        });
		}

		function updateQuestionChoice(slugObject, campaignPartId, questionId, choice) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/Part/' + campaignPartId +
						 '/Question/' + questionId +
						 '/Choice/' + choice.QuestionChoiceID;

		    return $http.put(reqUrl, { Choice: choice })
                        .then(function (response) {
                            return response.data;
                        });
		}

		function deleteQuestionChoice(slugObject, campaignPartId, questionId, choice) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/Part/' + campaignPartId +
						 '/Question/' + questionId +
						 '/Choice/' + choice.QuestionChoiceID;

		    return $http.delete(reqUrl, {})
                        .then(function (response) {
                            return response.data;
                        });
		}

		// Visual Component

		function createVisualComponent(slugObject, campaignPartId, component) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/Part/' + campaignPartId +
						 '/VisualComponent';

			return $http.post(reqUrl, { Component: component })
                        .then(function (response) {
                        	return response.data;
                        });
		}

		function deleteVisualComponent(slugObject, campaignPartId, component) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/Part/' + campaignPartId +
						 '/VisualComponent/' + component.VisualComponentID;

		    return $http.delete(reqUrl, {})
                        .then(function (response) {
                            return response.data;
                        });
		}

	    // Respondent

		function addCampaignRespondent(slugObject, respondent) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/Respondent';

		    return $http.post(reqUrl, { Respondent: respondent })
                        .then(function (response) {
                            return response.data;
                        });
		}

		function addRespondentWithSubordinates(slugObject, respondent) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/RespondentWithSubordinates';

		    return $http.post(reqUrl, { Respondent: respondent })
                        .then(function (response) {
                            return response.data;
                        });
		}

		function removeCampaignRespondent(slugObject, campaignRespondentId) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/Respondent/' + campaignRespondentId;

		    return $http.delete(reqUrl, {})
                        .then(function (response) {
                            return response.data;
                        });
		}

		function unlockCompletionCampaignRespondent(slugObject, campaignRespondentId) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/Respondent/' + campaignRespondentId;

		    return $http.post(reqUrl, {})
                        .then(function (response) {
                            return response.data;
                        });
		}

		function getCampaignRespondents(slugObject) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/Respondent';

		    return $http.get(reqUrl, {})
                        .then(function (response) {
                            return response.data;
                        });
		}

		function sendEmailToRepondent(slugObject, campaign, respondent) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/Respondent/' + respondent.CampaignRespondentID +
                         '/Email/Send';

		    var isDebug = env.isDev || undefined;

		    return $http.post(reqUrl, {
		        Campaign: campaign,
		        Respondent: respondent,
		        isDebug: isDebug
		    })
            .then(function (response) {
                return response.data;
            });
		}

	    // Owner

		function getCampaignOwners(slugObject) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/Owner';

		    return $http.get(reqUrl, {})
                        .then(function (response) {
                            return response.data;
                        });
		}

		function addCampaignOwner(slugObject, owner) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/Owner';

		    return $http.post(reqUrl, { Owner: owner })
                        .then(function (response) {
                            return response.data;
                        });
		}

		function removeCampaignOwner(slugObject, itemPersonId) {
		    var reqUrl = campaignUrl(slugObject) +
						 '/Owner/' + itemPersonId;

		    return $http.delete(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
		}
	}
})();
